import React from "react";
import LogsFilter from "../../components/Logs-Filter/LogsFilter";
import useLogsListing from "../../customHooks/LogsListing/useLogsListing";
import "./LogsListing.css";
import ReactJson from "react-json-view";
import Modal from "react-bootstrap/Modal";
import { LuClipboardCopy } from "react-icons/lu";
import { FaEye } from "react-icons/fa";
import toast, { Toaster } from "react-hot-toast";
import Pagination from "@mui/material/Pagination";
import { copyTextToClipboard } from "../../utils/helper";

const LogsListing = () => {
  const talonProps = useLogsListing();
  const {
    bppId,
    setBppId,
    messageId,
    setMessageId,
    transactionId,
    setTransactionId,
    loader,
    logs,
    actionType,
    setActionType,
    totalCount,
    pageSize,
    currentPage,
    setCurrentPage,
    handlePageChange,
    handleInputPageChange,
    handlePageSize,
    jsonBody,
    setJsonBody,
    openJson,
    setOpenJson,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    actionOptions,
    bapOptions,
    domainOptions,
    domain,
    setDomain,
    onHide,
    show,
    setShow,
    clearEndDate,
    clearStartDate,
    setClearEndDate,
    setClearStartDate,
    showConfirm,
    setShowConfirm,
    limit,
  } = talonProps;
  return (
    <>
      <Toaster
        position="top-center"
        reverseOrder={false}
        gutter={8}
        toastOptions={{
          success: {
            duration: 1500,
            theme: {
              primary: "green",
              secondary: "black",
            },
          },
        }}
      />
      <div className="mainDiv">
        <div className="screenRoot">
          <div className="screenTitleSections">
            <div className="screenTitle">Transaction Logs</div>
          </div>
        </div>
        <div className="screenBodyRoot">
          <div className="screenTableFeaturesRoot">
            <LogsFilter
              bppId={bppId}
              transactionId={transactionId}
              messageId={messageId}
              setMessageId={setMessageId}
              setBppId={setBppId}
              setTransactionId={setTransactionId}
              actionType={actionType}
              setActionType={setActionType}
              startDate={startDate}
              endDate={endDate}
              setEndDate={setEndDate}
              setStartDate={setStartDate}
              actionOptions={actionOptions}
              bapOptions={bapOptions}
              domainOptions={domainOptions}
              domain={domain}
              setDomain={setDomain}
            />
          </div>
          <div className="row d-flex justify-content-between mt-3">
            <div className="col-2 mt-2">
              Showing{" "}
              {logs && logs.length
                ? `${(currentPage - 1) * pageSize + 1} -
                  ${(currentPage - 1) * pageSize + logs.length}`
                : 0}{" "}
              of {totalCount || 0}
            </div>
            <div className="col-2 d-flex justify-content-center align-items-center pb-1">
              <label className="formLabels mx-2">Go&nbsp;to&nbsp;Page</label>
              <input
                type="text"
                value={currentPage || ""}
                id="currentPage"
                name="currentPage"
                onChange={handleInputPageChange}
                placeholder="Search page number"
                className="form-control"
              />
            </div>
          </div>

          {!loader ? (
            <>
              <div className="screenTableRecordsRoot logScreenRoot">
                {logs && logs.length
                  ? logs.map((log) => {
                      return (
                        <div className="logBody mb-3">
                          <div className="messageId">
                            Message Id : {log.message_id}{" "}
                            <span
                              className="copy-btn"
                              onClick={() => {
                                toast.success("Copied");
                                copyTextToClipboard(log.message_id);
                              }}
                            >
                              <LuClipboardCopy size={15} />
                            </span>
                          </div>
                          <div className="timestamp">
                            {new Date(log.createdAt)
                              .toString()
                              .split(" ")
                              .slice(0, 5)
                              .join(" ")}
                          </div>
                          <div className="transactionId">
                            Transaction Id : {log.transaction_id}{" "}
                            <span
                              className="copy-btn"
                              onClick={() => {
                                toast.success("Copied");
                                copyTextToClipboard(log.transaction_id);
                              }}
                            >
                              <LuClipboardCopy size={15} />
                            </span>
                          </div>
                          <div
                            className={`row px-3 pt-4 pb-2 grid-container grid-2x2`}
                          >
                            {log && log.request_payload && (
                              <div className="col-6 my-2">
                                <div className="typeTitle">
                                  Request Payload{" "}
                                  <span className="block_description">
                                    (Initiated By Buyer App)
                                  </span>
                                </div>
                                <div className="itemBody p-2">
                                  {JSON.stringify(log.request_payload, null, 2)}
                                  <span
                                    className="copy-btn-json"
                                    onClick={() => {
                                      toast.success("Copied");
                                      copyTextToClipboard(
                                        JSON.stringify(
                                          log.request_payload,
                                          null,
                                          2
                                        )
                                      );
                                    }}
                                  >
                                    <LuClipboardCopy size={20} />
                                  </span>

                                  <span
                                    className="show-more-btn"
                                    onClick={() => {
                                      setJsonBody(log.request_payload);
                                      setOpenJson(true);
                                    }}
                                  >
                                    <FaEye size={15} /> &nbsp;View
                                  </span>
                                </div>
                              </div>
                            )}
                            {log && log.callback_payload && (
                              <div className="col-6 my-2">
                                <div className="typeTitle">
                                  Callback Payload{" "}
                                  <span className="block_description">
                                    (Initiated By Seller App)
                                  </span>
                                </div>
                                <div className="itemBody p-2">
                                  {JSON.stringify(
                                    log.callback_payload,
                                    null,
                                    2
                                  )}
                                  <span
                                    className="copy-btn-json"
                                    onClick={() => {
                                      toast.success("Copied");
                                      copyTextToClipboard(
                                        JSON.stringify(
                                          log.callback_payload,
                                          null,
                                          2
                                        )
                                      );
                                    }}
                                  >
                                    <LuClipboardCopy size={20} />
                                  </span>
                                  <span
                                    className="show-more-btn"
                                    onClick={() => {
                                      setJsonBody(log.callback_payload);
                                      setOpenJson(true);
                                    }}
                                  >
                                    <FaEye size={15} />
                                    &nbsp; View
                                  </span>
                                </div>
                              </div>
                            )}
                            {log && log.request_response && (
                              <div className="col-6 my-2">
                                <div className="typeTitle">
                                  Request Response{" "}
                                  <span className="block_description">
                                    (Responded by Seller App for Buyer App's
                                    Request)
                                  </span>
                                </div>
                                <div className="itemBody p-2">
                                  {JSON.stringify(
                                    log.request_response,
                                    null,
                                    2
                                  )}
                                  <span
                                    className="copy-btn-json"
                                    onClick={() => {
                                      toast.success("Copied");
                                      copyTextToClipboard(
                                        JSON.stringify(
                                          log.request_response,
                                          null,
                                          2
                                        )
                                      );
                                    }}
                                  >
                                    <LuClipboardCopy size={20} />
                                  </span>
                                  <span
                                    className="show-more-btn"
                                    onClick={() => {
                                      setJsonBody(log.request_response);
                                      setOpenJson(true);
                                    }}
                                  >
                                    <FaEye size={15} /> &nbsp;View
                                  </span>
                                </div>
                              </div>
                            )}
                            {log && log.callback_response && (
                              <div className="col-6 my-2">
                                <div className="typeTitle">
                                  Callback Response{" "}
                                  <span className="block_description">
                                    (Responded by Buyer App for Seller App's
                                    Callback)
                                  </span>
                                </div>
                                <div className="itemBody p-2">
                                  {JSON.stringify(
                                    log.callback_response,
                                    null,
                                    2
                                  )}
                                  <span
                                    className="copy-btn-json"
                                    onClick={() => {
                                      toast.success("Copied");
                                      copyTextToClipboard(
                                        JSON.stringify(
                                          log.callback_response,
                                          null,
                                          2
                                        )
                                      );
                                    }}
                                  >
                                    <LuClipboardCopy size={20} />
                                  </span>
                                  <span
                                    className="show-more-btn"
                                    onClick={() => {
                                      setJsonBody(log.callback_response);
                                      setOpenJson(true);
                                    }}
                                  >
                                    <FaEye size={15} />
                                    &nbsp; View
                                  </span>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })
                  : null}
              </div>
              {totalCount > pageSize ? (
                <div className="screenTablePaginationRoot">
                  <Pagination
                    // component="div"
                    count={Math.ceil(totalCount / pageSize)}
                    page={currentPage}
                    onChange={handlePageChange}
                    // rowsPerPage={pageSize}
                    // onRowsPerPageChange={handlePageSize}
                  />
                </div>
              ) : null}
            </>
          ) : (
            <div className="screenTableRootLoader">{/* <SmallLoader /> */}</div>
          )}
        </div>
        <Modal
          show={openJson}
          onHide={() => setOpenJson(false)}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton />
          <Modal.Body>
            <div className="json-body">
              <ReactJson src={jsonBody} />
            </div>
          </Modal.Body>
          {/* <Modal.Footer>
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer> */}
        </Modal>
      </div>
    </>
  );
};

export default LogsListing;
